import React, { useEffect, lazy } from 'react';
import { useParams } from 'react-router-dom';
import { getSignById } from '../data/signs';
import { BackButton } from '../components/layout/BackButton';
import { SignHero } from '../components/sign/SignHero';
import { SignProblema } from '../components/sign/SignProblema';
import { SignSolucion } from '../components/sign/SignSolucion';
import { SignDescubrir } from '../components/sign/SignDescubrir';
import { VistaDelNucleo } from '../components/sign/VistaDelNucleo';
import { SignProductos } from '../components/sign/SignProductos';
import { SignReviews } from '../components/sign/SignReviews';
import { SignCTA } from '../components/sign/SignCTA';
import { FAQ } from '../components/home/FAQ';
const PROBLEMA_SOLUCION_BG = 'https://cdn.shopify.com/s/files/1/0661/3847/2542/files/Wo_P7B_zdv8m9RvhXj7oHsrVCD8DHmoaCV8LM93AvU4jwAaKiGqzNwGb4XYEagB9_tZ0TcHraHRe_tnjw_TqjyQZxuHl5rbrSK5lMOirgN3ahHy_2wo6yUvf1xmSggU58NRTNKzMv.jpg?v=1778629047';
export function SignPage() {
  const {
    signId
  } = useParams<{
    signId: string;
  }>();
  const sign = signId ? getSignById(signId) : null;
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
  }, [signId]);
  if (!sign) {
    return <div className="min-h-screen flex items-center justify-center bg-cosmic-black" data-id="element-535">
        <p className="text-white text-xl" data-id="element-536">Signo no encontrado</p>
      </div>;
  }
  return <div className="w-full bg-cosmic-black" data-id="element-537">
      <BackButton signColor={sign.colors.primary} data-id="element-538" />
      <SignHero sign={sign} data-id="element-539" />

      {/* Combined background for SignProblema + SignSolucion, tinted with sign color */}
      <div className="relative" data-id="element-540">
        <div className="absolute inset-0 z-0" data-id="element-541">
          <img src={PROBLEMA_SOLUCION_BG} alt="" aria-hidden="true" className="w-full h-full object-cover" loading="lazy" data-id="element-542" />
          <div className="absolute inset-0 bg-cosmic-black/75" data-id="element-543" />
          <div className="absolute inset-0" style={{
          backgroundColor: sign.colors.primary,
          opacity: 0.18
        }} data-id="element-544" />
          <div className="absolute inset-0" style={{
          background: `linear-gradient(180deg, #050508 0%, ${sign.colors.primary}15 50%, #050508 100%)`
        }} data-id="element-545" />
        </div>
        <div className="relative z-10" data-id="element-546">
          <SignProblema sign={sign} data-id="element-547" />
          <SignSolucion sign={sign} data-id="element-548" />
        </div>
      </div>

      <SignDescubrir sign={sign} data-id="element-549" />
      <VistaDelNucleo sign={sign} data-id="element-550" />
      <SignProductos sign={sign} data-id="element-551" />
      <SignReviews sign={sign} data-id="element-552" />
      <FAQ data-id="element-553" />
      <SignCTA sign={sign} data-id="element-554" />
    </div>;
}